// @vue/component
export default {
  name: 'CollapseAccordion',

  props: {
    text: {
      type: String,
      default: 'Rozwiń',
    },
    icon: {
      type: String,
      default: 'fa fa-caret-down',
    },
  },

  data() {
    return {
      isAccordionExpanded: false,
    };
  },
};
